import { render } from "./AtoProject.vue?vue&type=template&id=06e70ef2&scoped=true"
import script from "./AtoProject.vue?vue&type=script&lang=js"
export * from "./AtoProject.vue?vue&type=script&lang=js"

import "./AtoProject.vue?vue&type=style&index=0&id=06e70ef2&lang=scss"
import "./AtoProject.vue?vue&type=style&index=1&id=06e70ef2&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e70ef2"]])

export default __exports__